import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import { NavLink } from 'react-router'
import { LOGO_IMAGE } from '../../constants'

export interface LogoProps {
	width?: number
	sx?: any
	isMobile?: boolean
}

const mobileWidth = 90

export default function Logo({ width = 130, sx = {} }: LogoProps) {
	return (
		<Box
			sx={{
				position: 'relative',
				display: {
					xs: 'block',
					md: 'flex'
				},
				alignSelf: 'stretch',
				width: {
					xs: mobileWidth,
					md: width
				},
				mr: 1,
				...sx.root
			}}
		>
			<Box
				sx={{
					width: {
						xs: mobileWidth,
						md: width
					},
					borderRadius: '50%',
					overflow: 'hidden',
					position: 'absolute',
					top: 0,
					left: 0,
					...sx.imageWrap
				}}
			>
				<Link component={NavLink} to="/">
					<Box
						component="img"
						src={LOGO_IMAGE}
						alt="Wolf Dane Pug"
						width={{
							xs: mobileWidth,
							md: width
						}}
						height={{
							xs: mobileWidth,
							md: width
						}}
						sx={{ objectFit: 'contain', float: 'left' }}
					/>
				</Link>
			</Box>
		</Box>
	)
}
